import { render } from "./UserDetailsModal.vue?vue&type=template&id=fe8824d4&scoped=true"
import script from "./UserDetailsModal.vue?vue&type=script&lang=js"
export * from "./UserDetailsModal.vue?vue&type=script&lang=js"

import "./UserDetailsModal.vue?vue&type=style&index=0&id=fe8824d4&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8824d4"]])

export default __exports__